import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { updateSection } from "../../../assignmentSlice";

import { useTTS } from "../../../../../hooks/useTTS";

import { getContentHeight } from "../../../../../utils/textUtils";

import ArrowButton from "../../widgets/ArrowButton";

const ReadingPage = ({ setCurrentStep, isPreview, isReview }) => {
  const dispatch = useDispatch();
  const { section } = useSelector((state) => state.assignment);
  const [pageList, setPageList] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  let currentPage = pageList[currentIndex] || [];
  const hideTranslation = section.question?.hide_translation ?? false;

  if (hideTranslation) {
    currentPage = currentPage.slice(0, 1);
  }

  useEffect(() => {
    if (!section) return;
    setPageList(section.question.data);
  }, [section]);

  const { speak, stopSpeaking } = useTTS();

  const handleNextPage = () => {
    stopSpeaking();

    if (currentIndex < pageList.length - 1) {
      const nextPage = pageList[currentIndex + 1];
      speak({ text: nextPage[0] });
      setCurrentIndex(currentIndex + 1);
    } else {
      if (!isPreview && !isReview) {
        dispatch(
          updateSection({ sectionId: section.id, data: { is_finished: true } })
        );
      }
      alert("학습이 완료되었습니다.");
      setCurrentStep(2);
    }
  };

  const handlePreviousPage = () => {
    stopSpeaking();
    if (currentIndex > 0) {
      const prevPage = pageList[currentIndex - 1];
      speak({ text: prevPage[0] });
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handlePlay = () => {
    stopSpeaking(); // TTS 중지
    speak({ text: currentPage[0] }); // TTS 실행
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        height: getContentHeight(),
        padding: "0 40px",
        fontFamily: '"Noto Sans KR", sans-serif',
        backgroundColor: "#FFFFFF",
      }}
    >
      {/* 왼쪽 화살표 */}
      <ArrowButton
        direction="left"
        onClick={handlePreviousPage}
        visibleCondition={currentIndex > 0}
      />

      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "right",
          }}
        >
          <button
            style={{
              backgroundColor: "#000000",
              color: "#FFFFFF",
              padding: "10px 25px",
              borderRadius: "5px",
              cursor: "pointer",
              fontSize: "16px",
              marginBottom: "20px",
            }}
            onClick={handlePlay}
          >
            듣기 재생
          </button>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            padding: "20px",
            gap: "30px",
            backgroundColor: "#fff",
            borderRadius: "10px",
            fontSize: "24px",
          }}
        >
          {currentPage.map((sentence) => (
            <div
              style={{
                textAlign: "center",
              }}
            >
              {sentence}
            </div>
          ))}
        </div>
      </div>

      {/* 오른쪽 화살표 */}
      <ArrowButton
        direction="right"
        onClick={handleNextPage}
        visibleCondition={true}
      />
      <div
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          height: "70px",
          width: "100vw",
          backgroundColor: "#F6F8FA", // 바 색상
          color: "#737373",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {currentIndex + 1} / {pageList.length}
      </div>
    </div>
  );
};

export default ReadingPage;
